import React, { useState, useEffect } from "react";
import { producaov2 as api } from "../../../../../services/apis";
import { Button, Form, Input, Divider } from "semantic-ui-react";
import * as yup from "yup";

import { Container, Content, Title, Field, Label, InputFile } from "./styles";

import swal from "sweetalert";
import { Link, withRouter } from "react-router-dom";
import AdminMenu from "../../../../../components/Admin/MenuDetalhes/AdminMenu";
import { isAuthAdmin } from "../../../../../services/auth";

import { uploadImage } from "../../../../../utils/webseries/upload_imagens";

const CriarPlaylist = (props) => {
  const [playlist, setPlaylist] = useState({
    youtube_playlist_id: "",
    titulo: "",
    ordem: "",
    ativa: "1",
    publica: "1",
    slogan: "",
    id_host: "",
    especial_page_url: "",
    linkedin_event_url: "",
    link_manual_bordo: "",
    vertical_banner: "",
  });
  const [id, setId] = useState(null);

  const [listHosts, setListHosts] = useState(null);

  useEffect(() => {
    loadAuth();
  }, []);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  useEffect(() => {
    const id = window.location.href.split("?")[1];
    if (!id || id === "") {
      window.location.href = "/admin/webserie-episodio";
    }
    api
      .get(`webseries/playlist/${id}`)
      .then((res) => {
        if (res.data.length <= 0) {
          window.location.href = "/admin/webserie-episodio";
        }
        setPlaylist(res.data);
        setId(id);
      })
      .catch((err) =>
        swal(`Erro: ${err.message}`).then(
          () => (window.location.href = "/admin/webserie-episodio")
        )
      );
  }, []);

  useEffect(() => {
    api
      .get(`/webserie/colaboradores?filter=host`)
      .then((res) => setListHosts(res.data))
      .catch((err) =>
        swal("Não foi possível consultar os dados dos hosts - ", err.message)
      );
  }, []);

  const updateImage = async (imagem) => {
    const { status, message } = await uploadImage(imagem, "lives", [
      "image/jpg",
      "image/jpeg",
      "image/webp",
      "image/png",
    ]);

    if (!status) {
      swal("Ops!", message, "error");
      return;
    } else {
      setPlaylist({ ...playlist, vertical_banner: message });
      swal("Sucesso !", "Imagem upada com sucesso !", "success");
    }
  };

  const update = async () => {
    const colaboradorValidation = await yup.object().shape({
      youtube_playlist_id: yup
        .string("Necessário que informe o ID da playlist no youtube")
        .required("Necessário que informe o ID da playlist no youtube"),
      titulo: yup
        .string("Necessário que informe o titulo")
        .required("Necessário que informe o titulo"),
      ordem: yup
        .string("Necessário que informe a ordem")
        .required("Necessário que informe a ordem"),
      ativa: yup
        .string("Necessário que informe se está ativa")
        .required("Necessário que informe se está ativa"),
      publica: yup
        .string("Necessário que informe se é pública")
        .required("Necessário que informe se é pública"),
      slogan: yup
        .string("Necessário que informe  o site")
        .required("Necessário que informe o site"),
      id_host: yup
        .string("Necessário que informe o id do host")
        .required("Necessário que informe o o id do host"),
      vertical_banner: yup.string("Necessário o upload do banner vertical"),
      especial_page_url: yup.string(
        "Necessário que informe o link para a página especial"
      ),
      linkedin_event_url: yup.string(
        "Necessário que informe o evento no linkedin"
      ),
      link_manual_bordo: yup.string(
        "Necessário que informe o link do manual de bordo"
      ),
    });

    try {
      await colaboradorValidation.validate(playlist, { abortEarly: true });
      api
        .put(`/admin/webseries_playlist/${id}`, playlist)
        .then(async (res) => {
          swal("Sucesso na atualização !");
        })
        .catch((err) => {
          swal("Não foi possível criar o episodio", err, "").then((res) =>
            props.history.push("/admin/lives")
          );
        });
    } catch (err) {
      if (err instanceof yup.ValidationError) {
        swal("Erro!", `${err}`, "error");
        return;
      }
    }
  };

  return (
    <>
      <Container>
        <AdminMenu />
        <Content>
          <Title>Criar Playlist</Title>

          <Form>
            <Form.Group widths="equal">
              <Form.Field
                control={Input}
                label="Titulo da Playlist"
                placeholder="Titulo da Playlist"
                onChange={(e) => {
                  setPlaylist({ ...playlist, titulo: e.target.value });
                }}
                value={playlist.titulo}
              />
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field
                control={Input}
                label="ID da Playlist no Youtube"
                placeholder="ID da Playlist no Youtube"
                onChange={(e) => {
                  setPlaylist({
                    ...playlist,
                    youtube_playlist_id: e.target.value,
                  });
                }}
                value={playlist.youtube_playlist_id}
              />
            </Form.Group>
            <Form.Group widths="equal">
              <textarea
                control={Input}
                label="Slogan da Playlist"
                placeholder="Slogan da Playlist"
                value={playlist.slogan}
                onChange={(e) => {
                  setPlaylist({ ...playlist, slogan: e.target.value });
                }}
              />
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field
                control={Input}
                label="Link Manual de Bordo da Playlist"
                placeholder="Link Manual de Bordo Playlist"
                onChange={(e) => {
                  setPlaylist({
                    ...playlist,
                    link_manual_bordo: e.target.value,
                  });
                }}
                value={playlist.link_manual_bordo}
              />
            </Form.Group>
            <Form.Group widths="equal">
              <Field>
                <Label>Capa Vertical da Websérie</Label>
                <InputFile
                  name="capa"
                  type="file"
                  onChange={(e) => {
                    updateImage(e.target.files[0]);
                  }}
                />
                <div></div>
                <div>
                  <br />
                </div>
              </Field>
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field
                control={Input}
                label="Link da página da Playlist"
                placeholder="Link da página da Playlist"
                onChange={(e) => {
                  setPlaylist({
                    ...playlist,
                    especial_page_url: e.target.value,
                  });
                }}
                value={playlist.especial_page_url}
              />
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field
                control={Input}
                label="Link do linkedin da Playlist"
                placeholder="Link do linkedin  da Playlist"
                onChange={(e) => {
                  setPlaylist({
                    ...playlist,
                    linkedin_event_url: e.target.value,
                  });
                }}
                value={playlist.linkedin_event_url}
              />
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field
                control={Input}
                type={"number"}
                label="Ordem da Playlist"
                placeholder="Ordem da Playlist"
                onChange={(e) => {
                  setPlaylist({ ...playlist, ordem: e.target.value });
                }}
                value={playlist.ordem}
              />
            </Form.Group>

            <Form.Group widths="equal">
              <Form.Field>
                <Label> Ativa (Recebe novos episodio constantemente) </Label>

                <select
                  onChange={(e) =>
                    setPlaylist({ ...playlist, ativa: e.target.value })
                  }
                  value={playlist.ativa}
                >
                  <option value={"1"}>Sim</option>
                  <option value={"0"}> Não </option>
                </select>
              </Form.Field>
            </Form.Group>

            <Form.Group widths="equal">
              <Form.Field>
                <Label> Pública (Pode ser vista pelo público) </Label>

                <select
                  onChange={(e) =>
                    setPlaylist({ ...playlist, publica: e.target.value })
                  }
                  value={playlist.publica}
                >
                  <option value={"1"}>Sim</option>
                  <option value={"0"}>Não </option>
                </select>
              </Form.Field>
            </Form.Group>

            <Form.Group widths="equal">
              <Form.Field>
                <Label>
                  Host (
                  <a href={"/admin/webserie-colaborador/criar"}>
                    Cadastrar novo colaborador
                  </a>
                  ){" "}
                </Label>

                <select
                  onChange={(e) =>
                    setPlaylist({ ...playlist, id_host: e.target.value })
                  }
                  value={playlist.id_host}
                >
                  <option value={""}> ID do Host </option>

                  {listHosts?.map((host) => (
                    <option value={host.id}>{host.nome}</option>
                  ))}
                </select>
              </Form.Field>
            </Form.Group>

            <Divider hidden />
            <Form.Group>
              <Form.Field
                control={Button}
                onClick={() => {
                  update();
                }}
              >
                Enviar
              </Form.Field>
              <Link to="/admin/webserie-playlist">
                <Button color="secondary">Cancelar</Button>
              </Link>
            </Form.Group>
          </Form>
        </Content>
      </Container>
    </>
  );
};

export default withRouter(CriarPlaylist);
